import { render } from "./Styles.vue?vue&type=template&id=5e93c3e6"
import script from "./Styles.vue?vue&type=script&lang=js"
export * from "./Styles.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__